module.exports = __webpack_public_path__ + "img/monster.9af05938.png";